import React from "react";

const CozyView = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <circle className="u_fill" cx={10.727} cy={17.727} r={8.727} fill={fill} />
        <rect className="u_fill"
            x={22.364}
            y={16.273}
            width={11.636}
            height={2.909}
            rx={0.5}
            fill={fill}
        />
    </svg>
);

export default CozyView;
